/* TOO MUCH wishlist for guests: no app, no login. Saved product handles live in this browser (localStorage),
   newest first, max 100. Another phone or computer starts empty (say so on the wishlist page).
   - <tm-wishlist-button data-handle> : heart on cards and on the product page, a real <button aria-pressed>.
   - [data-tm-wl-count]               : count in the header icon (hidden at 0).
   - <tm-wishlist-page>               : /pages/wishlist, renders saved pieces from /products/<handle>.js.
   The state is applied before paint where the script is already cached; the heart never changes size, so
   switching state causes no layout shift. Other tabs stay in sync through the storage event. */
(function () {
  if (window.TMWishlist) return;

  var KEY = 'tm-wishlist-v1';
  var LIMIT = 100;

  function read() {
    try {
      var value = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, LIMIT)));
    } catch (error) {
      /* private mode or full storage: the heart still toggles for this page view */
    }
    memory = list.slice(0, LIMIT);
    announce();
  }

  var memory = read();

  function list() {
    return memory.slice();
  }

  function has(handle) {
    return memory.indexOf(handle) !== -1;
  }

  function add(handle) {
    if (!handle || has(handle)) return;
    write([handle].concat(memory));
  }

  function remove(handle) {
    write(memory.filter(function (h) { return h !== handle; }));
  }

  function toggle(handle) {
    if (has(handle)) remove(handle);
    else add(handle);
    return has(handle);
  }

  function announce() {
    document.dispatchEvent(new CustomEvent('tm:wishlist', { detail: { list: list() } }));
  }

  function syncAll() {
    document.querySelectorAll('tm-wishlist-button').forEach(function (el) {
      if (typeof el.sync === 'function') el.sync();
    });
    document.querySelectorAll('[data-tm-wl-count]').forEach(function (el) {
      var n = memory.length;
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
      var link = el.closest('[data-tm-wl-link]');
      if (link) {
        var base = link.getAttribute('data-label') || '';
        var many = link.getAttribute('data-label-count') || '';
        link.setAttribute('aria-label', n > 0 && many ? many.replace('[count]', String(n)) : base);
      }
    });
  }

  document.addEventListener('tm:wishlist', syncAll);
  window.addEventListener('storage', function (event) {
    if (event.key !== KEY) return;
    memory = read();
    announce();
  });

  window.TMWishlist = { list: list, has: has, add: add, remove: remove, toggle: toggle };

  /* ------------------------------------------------------------ heart button */
  class TmWishlistButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      if (!this._bound) {
        this._bound = true;
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          toggle(this.dataset.handle);
        });
      }
      this.sync();
    }

    sync() {
      if (!this.button) return;
      var on = has(this.dataset.handle);
      this.button.setAttribute('aria-pressed', on ? 'true' : 'false');
      var text = this.querySelector('[data-tm-wl-text]');
      if (text) text.textContent = on ? this.dataset.labelSaved || text.textContent : this.dataset.labelAdd || text.textContent;
    }
  }
  if (!customElements.get('tm-wishlist-button')) customElements.define('tm-wishlist-button', TmWishlistButton);

  /* ------------------------------------------------------------ wishlist page */
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function splitList(value) {
    return String(value || '')
      .split(',')
      .map(function (v) { return v.trim(); })
      .filter(Boolean);
  }

  class TmWishlistPage extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.grid = this.querySelector('[data-tm-wl-grid]');
      this.empty = this.querySelector('[data-tm-wl-empty]');
      this.countEl = this.querySelector('[data-tm-wl-page-count]');
      this.cache = new Map();
      this.render();
      document.addEventListener('tm:wishlist', () => this.render());
    }

    productUrl(handle) {
      var root = this.dataset.root || '/';
      if (root.slice(-1) !== '/') root += '/';
      return root + 'products/' + encodeURIComponent(handle);
    }

    fetchProduct(handle) {
      if (!this.cache.has(handle)) {
        this.cache.set(
          handle,
          fetch(this.productUrl(handle) + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : r.status === 404 ? 'gone' : null; })
            .catch(function () { return null; })
        );
      }
      return this.cache.get(handle);
    }

    money(cents) {
      var value = cents / 100;
      var active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      var format = this.dataset.moneyFormat;
      if (format && (!active || active === this.dataset.shopCurrency)) {
        var delimit = function (precision, thousands, decimal) {
          var parts = value.toFixed(precision).split('.');
          return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
        };
        var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        var amount;
        switch (match ? match[1] : 'amount') {
          case 'amount_no_decimals':
            amount = delimit(0, ',', '.');
            break;
          case 'amount_with_comma_separator':
            amount = delimit(2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            amount = delimit(0, '.', ',');
            break;
          default:
            amount = delimit(value % 1 === 0 ? 0 : 2, ',', '.');
        }
        return match ? format.replace(match[0], amount) : amount;
      }
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: active || this.dataset.shopCurrency || 'AED',
          maximumFractionDigits: value % 1 === 0 ? 0 : 2,
        }).format(value);
      } catch (error) {
        return String(value);
      }
    }

    brand(product) {
      var vendor = String(product.vendor || '').trim();
      var key = vendor.toLowerCase();
      var nonBrand = splitList(this.dataset.nonBrand).map(function (v) { return v.toLowerCase(); });
      var preloved = splitList(this.dataset.preloved).map(function (v) { return v.toLowerCase(); });
      var isPre = preloved.indexOf(key) !== -1;
      var name = isPre || nonBrand.indexOf(key) !== -1 ? '' : vendor;
      if (!name) {
        var tags = (product.tags || []).map(function (t) { return String(t).toLowerCase(); });
        splitList(this.dataset.brandTags).some(function (rule) {
          var parts = rule.split(':');
          var tag = parts[0].trim();
          if (tags.indexOf(tag.toLowerCase()) === -1) return false;
          name = (parts[1] || '').trim() || tag;
          return true;
        });
      }
      var badge = '';
      if (isPre) badge = '<span class="tm-badge tm-badge--preloved">' + esc(this.dataset.prelovedBadge) + '</span>';
      else if (!name) badge = '<span class="tm-badge tm-badge--selection">' + esc(this.dataset.selectionBadge) + '</span>';
      if (!name && !badge) return '';
      return '<div class="tm-brand tm-brand--card">' + (name ? '<span class="tm-brand__name">' + esc(name) + '</span>' : '') + badge + '</div>';
    }

    card(handle, product) {
      var url = this.productUrl(handle);
      var image = product.featured_image || (product.images && product.images[0]) || '';
      var join = image.indexOf('?') === -1 ? '?' : '&';
      var available = (product.variants || []).filter(function (v) { return v.available; });
      var single = (product.variants || []).length === 1;
      var action = '';
      if (!product.available) {
        action = '<span class="tm-wl-card__sold">' + esc(this.dataset.soldLabel) + '</span>';
      } else if (single && available[0]) {
        action =
          '<factory-add-button class="tm-wl-card__add" data-variant-id="' + available[0].id + '" data-quantity="1" data-context="product">' +
          '<button type="button" class="button tm-wl-card__button">' + esc(this.dataset.addLabel) + '</button>' +
          '<p class="tm-wl-card__error" data-factory-error role="alert" hidden></p></factory-add-button>';
      } else {
        action = '<a class="button button-secondary tm-wl-card__button" href="' + url + '">' + esc(this.dataset.chooseLabel) + '</a>';
      }
      var compare = product.compare_at_price && product.compare_at_price > product.price
        ? ' <s class="tm-wl-card__compare">' + esc(this.money(product.compare_at_price)) + '</s>' : '';
      return (
        '<li class="tm-wl-card" data-handle="' + esc(handle) + '">' +
        '<div class="tm-wl-card__visual"><a class="tm-wl-card__media" href="' + url + '" tabindex="-1" aria-hidden="true">' +
        (image ? '<img src="' + esc(image + join + 'width=720') + '" alt="" loading="lazy" width="720" height="900">' : '') + '</a>' +
        '<tm-wishlist-button class="tm-wl tm-wl--card" data-handle="' + esc(handle) + '">' +
        '<button type="button" class="tm-wl__button" aria-pressed="true" aria-label="' + esc(this.dataset.heartLabel) + ': ' + esc(product.title) + '">' +
        this.dataset.heartIcon + '</button></tm-wishlist-button></div>' +
        '<div class="tm-wl-card__info">' + this.brand(product) +
        '<a class="tm-wl-card__title" href="' + url + '">' + esc(product.title) + '</a>' +
        '<p class="tm-wl-card__price">' + esc(this.money(product.price)) + compare + '</p>' +
        '<div class="tm-wl-card__actions">' + action +
        '<button type="button" class="tm-wl-card__remove" data-tm-wl-remove="' + esc(handle) + '">' + esc(this.dataset.removeLabel) + '</button></div>' +
        '</div></li>'
      );
    }

    async render() {
      var handles = list();
      var token = (this._token = (this._token || 0) + 1);
      if (this.countEl) this.countEl.textContent = handles.length ? String(handles.length) : '';
      if (!handles.length) {
        this.grid.innerHTML = '';
        this.grid.hidden = true;
        this.empty.hidden = false;
        this.removeAttribute('aria-busy');
        return;
      }
      this.setAttribute('aria-busy', 'true');
      var results = await Promise.all(handles.map((h) => this.fetchProduct(h)));
      if (token !== this._token) return;
      var html = '';
      var self = this;
      handles.forEach(function (handle, i) {
        var product = results[i];
        if (product === 'gone') {
          remove(handle);
          return;
        }
        if (product) html += self.card(handle, product);
      });
      this.grid.innerHTML = html;
      this.grid.hidden = !html;
      this.empty.hidden = Boolean(html);
      this.removeAttribute('aria-busy');
      this.grid.querySelectorAll('[data-tm-wl-remove]').forEach(function (button) {
        button.addEventListener('click', function () { remove(button.getAttribute('data-tm-wl-remove')); });
      });
    }
  }
  if (!customElements.get('tm-wishlist-page')) customElements.define('tm-wishlist-page', TmWishlistPage);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
  else syncAll();
})();
